import styled from "styled-components";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Bio } from "../../data/constants";

// Container with soft gradient & backdrop
const FooterContainer = styled.div`
  width: 100%;
  background: linear-gradient(
    180deg,
    #0a0a1a 0%,
    /* matches section above */ rgba(133, 76, 230, 0.08) 40%,
    rgba(0, 102, 255, 0.08) 100%
  );
  padding: 3rem 1rem 1rem 1rem;
  display: flex;
  justify-content: center;
`;

const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.8rem;
  color: ${({ theme }) => theme.text_primary};
`;

const Logo = styled.h1`
  font-weight: 700;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.primary};
  letter-spacing: 1px;
`;

const Nav = styled.nav`
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const NavLink = styled.a`
  position: relative;
  color: ${({ theme }) => theme.text_primary};
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 500;
  transition: all 0.3s ease;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 0%;
    height: 2px;
    background: ${({ theme }) => theme.primary};
    transition: width 0.3s ease;
    border-radius: 2px;
  }

  &:hover {
    color: ${({ theme }) => theme.primary};
  }

  &:hover:after {
    width: 100%;
  }
`;

const SocialMediaIcons = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const SocialMediaIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  color: ${({ theme }) => theme.text_secondary};
  transition: all 0.3s ease;
  border-radius: 50%;
  width: 42px;
  height: 42px;

  &:hover {
    color: ${({ theme }) => theme.white};
    background: ${({ theme }) => theme.primary};
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(133, 76, 230, 0.4);
  }
`;

const Copyright = styled.div`
  text-align: center;
  font-size: 0.9rem;
  font-weight: 400;
  color: ${({ theme }) => theme.text_secondary};
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  b {
    color: ${({ theme }) => theme.text_primary};
  }
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterWrapper>
        <Logo>Sagar Arya</Logo>

        <Nav>
          <NavLink href="#about">About</NavLink>
          <NavLink href="#skills">Skills</NavLink>
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#education">Education</NavLink>
        </Nav>

        <SocialMediaIcons>
          <SocialMediaIcon href={Bio.facebook} target="_blank">
            <FacebookIcon />
          </SocialMediaIcon>
          <SocialMediaIcon href={Bio.twitter} target="_blank">
            <TwitterIcon />
          </SocialMediaIcon>
          <SocialMediaIcon href={Bio.linkedin} target="_blank">
            <LinkedInIcon />
          </SocialMediaIcon>
          <SocialMediaIcon href={Bio.insta} target="_blank">
            <InstagramIcon />
          </SocialMediaIcon>
        </SocialMediaIcons>

        <Copyright>
          © {new Date().getFullYear()} • Made with ❤️ by <b>Sagar Arya</b> • All
          rights reserved.
        </Copyright>
      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;
